import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./layout/layout";
import NotFound from "./component/404/notFound";
import Loader from "./component/loader/loader";

const Home = lazy(() => import("./page/Home"));
const Shop = lazy(() => import("./page/Shop"));
const ShopDetail = lazy(() => import("./page/ShopDetail"));

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product-details" element={<ShopDetail />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
